export let hres6luColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'dteot',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '70',
      style: 'min-width: 200px;',
      dataType: 'dateRange'
    }, {
      key: 'timot',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 350px;',
      headerRow: 1,
      colspan: 3,
      rowspan: 1
    }, {
      key: 'timbstr',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '90',
      class: 'align-center',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'timdstr',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '100',
      class: 'align-center',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'timastr',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '110',
      class: 'align-center',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES6LUC2',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'desrem',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '150',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES6LUC1',
      labelIndex: '170',
      style: 'min-width: 200px;'
    }
  ]

  let detailTab2Columns = [
    {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6LUC3',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'typwork',
      name: '',
      labelCodapp: 'HRES6LUC3',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'typot',
      name: '',
      labelCodapp: 'HRES6LUC3',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'v_ot_time',
      name: '',
      labelCodapp: 'HRES6LUC3',
      labelIndex: '70+80',
      class: 'align-center',
      style: 'min-width: 200px;'
    }
  ]

  let detailTab3Columns = [
    {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6LUC4',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'typwork',
      name: '',
      labelCodapp: 'HRES6LUC4',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRES6LUC4',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'timework',
      name: '',
      labelCodapp: 'HRES6LUC4',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 200px;'
    }, {
      key: 'timin',
      name: '',
      labelCodapp: 'HRES6LUC4',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'timout',
      name: '',
      labelCodapp: 'HRES6LUC4',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 100px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab2: detailTab2Columns,
      detailTab3: detailTab3Columns
    },
    th: {
      index: indexColumns,
      detailTab2: detailTab2Columns,
      detailTab3: detailTab3Columns
    }
  }
}

export let hres6luMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6lu.js